"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridNormalCell = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../../../Grid/cellRenderers/helpers");
const GridCore_1 = require("../../../..");
const GridCoreSkeleton_1 = require("../../../../components/GridCoreSkeleton/GridCoreSkeleton");
const GridNormalCellRenderer_1 = require("../GridNormalCellRenderer/GridNormalCellRenderer");
const Text_1 = require("../../../../../Text");
const Tooltip_1 = require("../../../../../Tooltip");
exports.GridNormalCell = react_1.default.memo(function GridNormalCell({ content, tooltipMaxWidth, columnWidth, highlighted, disabled, inactive, justify, loading, hasBigLeftIntent, hasPaddings, columnId }) {
    const ref = (0, react_1.useRef)(null);
    const isText = (0, react_1.useMemo)(() => typeof content === 'string' || typeof content === 'number', [content]);
    const isHighlighted = (0, react_1.useMemo)(() => !!highlighted && !disabled && !inactive, [disabled, highlighted, inactive]);
    const contentRender = (0, react_1.useMemo)(() => (loading ? react_1.default.createElement(GridCoreSkeleton_1.GridCoreSkeleton, null) : content), [content, loading]);
    return (0, Tooltip_1.useTooltip)({
        delayTimeout: 500,
        isActive: isText,
        maxWidth: `${tooltipMaxWidth || columnWidth + 50}px`,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, content),
        render: (tooltipProps) => {
            return (react_1.default.createElement(GridNormalCellRenderer_1.GridNormalCellRenderer, { isHighlighted: isHighlighted, disabled: disabled, inactive: inactive, innerRef: ref, columnId: columnId, hasBigLeftIntent: hasBigLeftIntent, hasPaddings: hasPaddings, textJustifyEnd: justify === GridCore_1.COLUMN_CONTENT_JUSTIFY.end, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }, contentRender));
        }
    });
});
//# sourceMappingURL=GridNormalCell.js.map